import React, { ChangeEvent, Component } from "react";
import IErrorDTO from "../../../../models/DTO/IErrorDTO";
import IGetShippingWeightTiersDTO from "../../../../models/DTO/IGetShippingWeightTiersDTO";
import IGetShippingZonesDTO from "../../../../models/DTO/IGetShippingZonesDTO";
import IOnGetShippingWeightTiersDTO from "../../../../models/DTO/IOnGetShippingWeightTiersDTO";
import IOnGetShippingZonesDTO from "../../../../models/DTO/IOnGetShippingZonesDTO";
import IOnProcessShippingWeightTiersDTO from "../../../../models/DTO/IOnProcessShippingWeightTiersDTO";
import IProcessShippingWeightTiersDTO from "../../../../models/DTO/IProcessShippingWeightTiersDTO";
import EndpointsEnum from "../../../../models/EndpointsEnum";
import INotification from "../../../../models/INotification";
import IShipping_Weight_Tier from "../../../../models/IShipping_Weight_Tier";
import IShipping_Zone from "../../../../models/IShipping_Zone";
import ISupplierModel from "../../../../models/ISupplierModel";
import IUserUI from "../../../../models/IUserUI";
import OwButton from "../../../shared/OwButton/OwButton";
import OwInputWrapper from "../../../shared/OwInputWrapper/OwInputWrapper";
import OwLabel from "../../../shared/OwLabel/OwLabel";
import OwSelectOption from "../../../shared/OwSelectOption/OwSelectOption";
import OwTitle from "../../../shared/OwTitle/OwTitle";
import * as _ from "lodash-es";
import "./ShippingWeightTiersSidebar.scss";
import { Socket } from "socket.io-client";
import HelperService from "../../../../services/HelperService";
import { ConfirmDeleteOverlayFn } from "../../../shared/ConfirmDeleteOverlayFn/ConfirmDeleteOverlayFn";
import { OwDeleteEditActions } from "../../../shared/OwDeleteEditActions/OwDeleteEditActions";
import { FormattedNumber } from "react-intl"

type Props = {
    cancelFn: (refreshData?: boolean) => void;
    userModel: IUserUI;
    supplierModel: ISupplierModel;
    setActivityIndicator: (activityIndicator: boolean) => void;
    socket: Socket;
    notifyFn: (data: IErrorDTO | null, _notification?: INotification, isFormatted?: boolean) => void;
};

type State = {
    createActive: boolean;
    start_weight: number;
    end_weight: number;
    shipping_zone_id?: number;
    shippingZones: IShipping_Zone[];
    amount: number;
    shippingWeightTiers: IShipping_Weight_Tier[];
    shipping_state?: string;
    shippingStates: { value: string; title: string }[];
    targetDelete: string | null;
    selectedTier: IShipping_Weight_Tier | null;
};

class ShippingZoneWeightTiersSidebar extends Component<Props, State> {
    constructor(props: any) {
        super(props);

        this.state = {
            createActive: false,
            start_weight: 0,
            end_weight: 0,
            shippingZones: [],
            amount: 0,
            shippingWeightTiers: [],
            shippingStates: HelperService.getUsStates(),
            targetDelete: null,
            selectedTier: null,
        };
    }

    componentDidMount(): void {
        this.props.socket.on(EndpointsEnum.ShipmentOnGetShippingZones, this.onGetShippingZones);
        this.props.socket.on(EndpointsEnum.ShipmentOnGetShippingWeightTiers, this.onGetShippingWeightTiers);
        this.props.socket.on(EndpointsEnum.ShipmentOnProcessShippingWeightTiers, this.onProcessShippingWeightTiers);

        this.getShippingWeightTiers();
        this.getShippingZones();
    }

    componentWillUnmount(): void {
        this.props.socket.removeListener(EndpointsEnum.ShipmentOnGetShippingZones, this.onGetShippingZones);
        this.props.socket.removeListener(EndpointsEnum.ShipmentOnGetShippingWeightTiers, this.onGetShippingWeightTiers);
        this.props.socket.removeListener(EndpointsEnum.ShipmentOnProcessShippingWeightTiers, this.onProcessShippingWeightTiers);
    }

    getShippingZones = () => {
        const payload: IGetShippingZonesDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
        };

        this.props.socket.emit(EndpointsEnum.ShipmentGetShippingZones, payload);
    };

    onGetShippingZones = (data: IOnGetShippingZonesDTO) => {
        this.setState({
            shippingZones: data.shippingZones,
        });
    };

    cancel = (refreshData?: boolean) => {
        this.props.cancelFn(refreshData);
    };

    create = () => {
        const payload: IProcessShippingWeightTiersDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
            shippingWeightTiers: [
                {
                    amount: this.state.amount,
                    start_weight: this.state.start_weight,
                    end_weight: null,
                    shipping_zone_id: this.state.shipping_zone_id,
                    supplier_id: this.props.supplierModel.id,
                    shipping_state: this.state.shipping_state,
                },
            ],
        };

        if (this.state.end_weight) {
            payload.shippingWeightTiers[0].end_weight = this.state.end_weight;
        }

        this.props.socket.emit(EndpointsEnum.ShipmentProcessShippingWeightTiers, payload);

        this.setState({
            createActive: true,
            amount: 0,
            start_weight: 0,
            end_weight: 0,
            shipping_zone_id: undefined,
        });
    };

    onProcessShippingWeightTiers = (data: IOnProcessShippingWeightTiersDTO) => {
        this.getShippingWeightTiers();
    };

    getShippingWeightTiers = () => {
        const payload: IGetShippingWeightTiersDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
        };

        this.props.socket.emit(EndpointsEnum.ShipmentGetShippingWeightTiers, payload);
    };

    onGetShippingWeightTiers = (data: IOnGetShippingWeightTiersDTO) => {
        const shippingWeightTiers = _.sortBy(data.shippingWeightTiers, ["shipping_zone_id", "start_weight"]);

        this.setState({
            shippingWeightTiers,
            createActive: false,
        });
    };

    handleChange = (e: ChangeEvent<any>) => {
        const value = e.target.type === "checked" ? e.target.checked : e.target.value;
        const name = e.target.name;

        const state: any = {
            [name]: value,
        };

        this.setState(state);
    };

    deleteTier = () => {
        if (this.state.selectedTier) {
            const payload: IProcessShippingWeightTiersDTO = {
                userGuid: this.props.userModel.guid,
                userToken: this.props.userModel.token,
                supplierGuid: this.props.supplierModel.guid,
                shippingWeightTiers: [
                    {
                        ...this.state.selectedTier,
                        deleteFlag: true,
                    },
                ],
            };

            this.props.socket.emit(EndpointsEnum.ShipmentProcessShippingWeightTiers, payload);

            this.setState({
                targetDelete: null,
                selectedTier: null,
            });
        }
    };

    cancelDelete = () => {
        this.setState({
            targetDelete: null,
            selectedTier: null,
        });
    };

    confirmDelete = (tier: IShipping_Weight_Tier, index: number) => {
        console.log("confirmDelete", tier, index);

        this.setState({
            targetDelete: `row-${index}`,
            selectedTier: tier,
        });
    };

    render() {
        return (
            <div className={"ShippingWeightTiersSidebar p-2 position-relative"} id={"ShippingWeightTiersSidebar"}>
                <ConfirmDeleteOverlayFn
                    targetElem={this.state.targetDelete}
                    handleConfirm={this.deleteTier}
                    handleCancel={this.cancelDelete}
                    skipMainView={true}
                    skipLeftAdjustment={true}
                />

                <div className={"col-12"}>
                    <div className="text-end">
                        <button
                            className="btn btn-danger btn-sm"
                            onClick={() => {
                                this.cancel();
                            }}>
                            <i className="far fa-times" />
                        </button>
                    </div>
                    <OwTitle
                        className={"mb-2"}
                        leftIconName={"fad fa-layer-group"}
                        title={
                            this.props.supplierModel.has_shipping_by_weight_state
                                ? "shipping_state_weight_tiers"
                                : "shipping_zone_weight_tiers"
                        }
                    />
                    <hr />
                </div>

                <div className={"row"}>
                    <div className={"d-flex col-12"}>
                        <div>
                            <OwLabel title={"start_weight"} />
                            <OwInputWrapper name={"start_weight"} fn={this.handleChange} value={this.state.start_weight} />
                        </div>
                        <div className={"ms-2"}>
                            <OwLabel title={"end_weight"} />
                            <OwInputWrapper name={"end_weight"} fn={this.handleChange} value={this.state.end_weight} />
                        </div>
                        <div className={"ms-2"}>
                            <OwLabel title={"amount"} />
                            <OwInputWrapper name={"amount"} fn={this.handleChange} value={this.state.amount} />
                        </div>
                        <div className={"ms-2"}>
                            <OwLabel title={this.props.supplierModel.has_shipping_by_weight_state ? "shipping_state" : "shipping_zone"} />
                            {this.props.supplierModel.has_shipping_by_weight_state ? (
                                <OwSelectOption
                                    name={"shipping_state"}
                                    titleProp={"title"}
                                    valueProp={"value"}
                                    options={this.state.shippingStates}
                                    fn={this.handleChange}
                                    selectedOption={this.state}
                                    selectedOptionProp={"shipping_state"}
                                />
                            ) : (
                                <OwSelectOption
                                    name={"shipping_zone_id"}
                                    titleProp={"name"}
                                    valueProp={"id"}
                                    options={this.state.shippingZones}
                                    fn={this.handleChange}
                                    selectedOption={this.state}
                                    selectedOptionProp={"shipping_zone_id"}
                                />
                            )}
                        </div>
                        <div className={"ms-2"}>
                            <OwLabel title={" "} skipTranslate={true} />
                            <div>
                                <OwButton title={"create"} fn={this.create} active={this.state.createActive} disableOnActive={true} />
                            </div>
                        </div>
                    </div>
                </div>

                <div className={"mt-4"}>
                    <div className={"row"}>
                        <div className={"col"}></div>
                        <div className={"col "}>
                            <OwLabel title={"start_weight"} />
                        </div>
                        <div className={"col text-center"}>
                            <OwLabel title={"end_weight"} />
                        </div>
                        <div className={"col text-end"}>
                            <OwLabel title={"amount"} />
                        </div>
                        <div className={"col text-end"}>
                            <OwLabel title={this.props.supplierModel.has_shipping_by_weight_state ? "shipping_state" : "shipping_zone"} />
                        </div>
                    </div>

                    {this.state.shippingWeightTiers.map((tier, index: number) => {
                        return (
                            <div key={tier.guid} className={"row py-2"} id={`row-${index}`}>
                                <div className={"col"}>
                                    <OwDeleteEditActions
                                        isEditMode={false}
                                        onTrashClickFn={() => {
                                            this.confirmDelete(tier, index);
                                        }}
                                        onEditClickFn={() => {}}
                                        hideEdit={true}
                                        className={"me-2"}
                                    />
                                </div>
                                <div className={"col text-center"}>{tier.start_weight}</div>
                                <div className={"col text-center"}>{tier.end_weight && tier.end_weight > 0 ? tier.end_weight : "--"}</div>
                                <div className={"col text-end"}>
                                    <FormattedNumber
                                        value={tier.amount}
                                        style={"currency"}
                                        currency={"USD"}
                                        maximumFractionDigits={2}
                                        minimumFractionDigits={2}
                                        currencySign={"standard"}
                                        currencyDisplay={"symbol"}
                                    />
                                </div>
                                <div className={"col text-end"}>
                                    {this.props.supplierModel.has_shipping_by_weight_state
                                        ? tier.shipping_state
                                        : tier.Shipping_Zone?.name || "--"}
                                </div>
                            </div>
                        );
                    })}
                </div>

                <div></div>
            </div>
        );
    }
}

export default ShippingZoneWeightTiersSidebar;
